import CommonTable from 'components/table/CommonTable';
import { PropertyOwner } from 'models/Owner';
import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import useTable from 'components/table/hooks/useTable';
import { parseISO } from 'date-fns';
import { TableItemOwner } from '../../PropertySettingsOwnersTab.types';
import { TableWrapper } from '../../PropertySettingsOwnersTab.styles';
import ActionsCell from './cells/ActionsCell';

const PropertySettingsOwnersTable = ({ owner }: { owner: PropertyOwner }) => {
  const { t } = useTranslation();

  const formattedOwner = {
    fullName: `${owner?.firstName || ''} ${owner?.lastName || ''}`,
    ...owner,
  } satisfies TableItemOwner;

  const columnHelper = createColumnHelper<TableItemOwner>();

  const columns = [
    columnHelper.accessor('fullName', {
      header: t('common.name'),
      enableSorting: false,
    }),
    columnHelper.accessor('email', {
      header: t('common.email'),
      enableSorting: false,
    }),
    columnHelper.accessor('lastLoginUtcDateTime', {
      header: t('pageProperty.owners.loginStatus'),
      enableSorting: false,
      cell: ({ getValue }) => {
        const lastLoginUtcDateTime = getValue();

        return lastLoginUtcDateTime
          ? t('pageProperty.owners.lastLogin', {
              date: parseISO(lastLoginUtcDateTime),
            })
          : t('pageProperty.owners.notSignedIn');
      },
    }),
    columnHelper.accessor('agencyCommissionRate', {
      header: t('pageProperty.owners.agencyCommission'),
      enableSorting: false,
      cell: ({ getValue }) => `${getValue()}%`,
    }),
    columnHelper.display({
      id: 'actions',
      header: t('common.actions'),
      cell: ActionsCell,
      meta: {
        showCellTooltip: false,
      },
    }),
  ];

  const tableInstance = useTable({
    data: [formattedOwner],
    columns,
    manualPagination: true,
    pageCount: 1,
  });

  return (
    <TableWrapper>
      <CommonTable
        tableInstance={tableInstance}
        data-testid="property-owners-table"
        rightOffset={190}
      />
    </TableWrapper>
  );
};

export default PropertySettingsOwnersTable;
